<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-map-contact">
            <baidu-map class="bm-view"
                       :center="{ lng: 121.4095, lat: 31.1796 }"
                       :zoom="15"
                       :scroll-wheel-zoom="true">
              <bm-marker :position="{ lng: 121.4095, lat: 31.1796 }"
                         :dragging="true"
                         animation="BMAP_ANIMATION_BOUNCE" />
            </baidu-map>
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
    <v-copy></v-copy>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
export default {
  data () {
    return {
      richText: '',
    };
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }

/* 地图 */
.b-map-contact {
  width: 1120px;
  .bm-view {
    width: 1120px;
    height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contact/index.vue